import { API_CONFIG, getApiUrl } from '../config/api';
import { SubscribeRequest, SubscribeResponse } from '../types/api';

export const subscribePlan = async (
  msisdn: string,
  planId: string
): Promise<SubscribeResponse> => {
  const payload: SubscribeRequest = {
    msisdn,
    plan_id: planId,
  };

  const response = await fetch(getApiUrl(API_CONFIG.endpoints.subscribe), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data: SubscribeResponse = await response.json();
  return data;
};
